/* eslint-disable @typescript-eslint/no-unused-vars */
import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
// import mixpanel from 'mixpanel-browser'
import React, { Dispatch, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SignUpModal } from 'src/components/global/SignUpModal'
// import { MIXPANEL_ENABLED } from 'src/config/config'
import {
  // IEnum_Solution_Type,
  // useFollowSolutionMutation,
  useFollowSubtopicMutation,
  useUserInfoLazyQuery,
  // useIsFollowLazyQuery
} from 'src/graphql/generated/hooks'
import { useAuthenticated } from 'src/hooks/useAuthenticated'
import { showToast } from 'src/store/actions/toastAction'
import { AppState } from 'src/store/types'

interface FollowSubTopicButtonProps {
  id: string
  subTopic?: any | null
  displayName?: string | null
  isEnhanced?: boolean | null
  isButton?: boolean
  className?: string
  follow?: boolean
  isFromSubTopic?: boolean
  followed?: boolean
  setFollowed?: (followed: boolean) => void
}

/**
 * Primary UI component for user interaction
 */
export const FollowSubTopicButton: React.FC<FollowSubTopicButtonProps> = ({
  id,
  subTopic = null,
  displayName,
  isEnhanced = false,
  className,
  isButton = true,
  follow = false,
  isFromSubTopic = false,
  followed = false,
  setFollowed,
}) => {
  const { status } = useAuthenticated()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: Dispatch<any> = useDispatch()
  const [loadUserInfo, { loading, data: userInfoData }] = useUserInfoLazyQuery()
  const user = userInfoData?.userInfo
  const [subtopicButtonRefresh, setSubtopicButtonRefresh] = useState<boolean>()
  const authInfo = useSelector((state: AppState) => state.authInfo)
  const [userData, setUserData] = useState<any>()
  const [subTopicData, setSubTopicData] = useState<any>({})

  const [following, setFollowing] = useState(!!followed)
  const [showSignUp, setShowSignUp] = useState(false)
  // const [loadIsFollowing, { data: isFollowingData }] = useIsFollowLazyQuery()
  const [followSubtopic] = useFollowSubtopicMutation()

  useEffect(() => {
    setFollowing(followed)
  }, [followed])

  const onHandleFollow = async () => {
    if (status !== 'authenticated') {
      setShowSignUp(true)
      return
    }

    if (authInfo.idToken !== undefined && authInfo.idToken !== '') {
      const isFollowing = !following
      const { data } = await followSubtopic({
        variables: {
          id: subTopic.documentId,
          follow: isFollowing,
        },
      })

      if (data?.followSubtopic) {
        dispatch(
          showToast(
            isFollowing ? 'Added to your followed categories' : 'Removed from your followed categories',
            'followedSubtopics',
          ),
        )
        if (setFollowed) {
          setFollowed(isFollowing)
        }
        setFollowing(isFollowing)
      }
    }
  }
  useEffect(() => {
    setSubtopicButtonRefresh(isFromSubTopic)
  }, [isFromSubTopic]) // Now it updates when isFromSubTopic changes
  const handleCloseSignUp = () => {
    setShowSignUp(false)
  }

  return (
    <div className={cn('flex', className)}>
      {isButton ? (
        <button className="box-border h-[42px] w-[auto] border-solid border-[1px] border-mist rounded-[25px] bg-white items-center">
          <div className="px-[16px] py-[10px] flex items-center justify-center" onClick={onHandleFollow}>
            {following ? (
              <IonIcon name="star" className="block text-[#011D58] text-[1.3rem] mr-[5px]" />
            ) : (
              <IonIcon name="star-outline" className="block text-[#333333] text-[1.3rem] mr-[5px]" />
            )}
            <span
              className={`block font-secondary text-[14px] font-[500] ${following ? 'text-[#011D58]' : 'text-[#333333]'}`}
            >
              {following ? 'Following' : 'Follow'} {subtopicButtonRefresh && 'Category'}
            </span>
          </div>
        </button>
      ) : (
        <button className="flex flex-row items-center h-[1.5rem] ml-[1rem] w-[91px]" onClick={onHandleFollow}>
          {following ? (
            <IonIcon name="star" className="text-navy text-[#011D58]" />
          ) : (
            <IonIcon name="star-outline" className="text-[#333333] opacity-40" />
          )}

          <span
            className={`pl-2 font-secondary font-medium text-[14px] ${following ? 'text-[#011D58]' : 'text-[#333333]'}`}
          >
            {following ? 'Following' : 'Follow'}
          </span>
        </button>
      )}

      <SignUpModal isOpen={showSignUp} onClose={handleCloseSignUp} />
    </div>
  )
}
